module.exports = __webpack_public_path__ + "4084a47ac93df48f1d30c71937064b34.pdf";